import { configureStore } from "@reduxjs/toolkit"
import filesAndFoldersSlice from "./slices/filesAndFoldersSlice"
import campaignsSlice from "./slices/campaignSlice.js"
import adSetsSlice from "./slices/adSetsSlice.js"
import allAdSetsSlice from "./slices/allAdSetsSlice.js"
import authSlice from "./slices/authSlice.js"
import userSlice from "./slices/userSlice.js"
import adsSlice from "./slices/adsSlice.js"
import landingPagesSlice from "./slices/landingPagesSlice.js"
import adCopiesSlice from "./slices/adCopiesSlice.js"
import facebookPagesSlice from "./slices/facebookPagesSlice.js"
import defaultValuesSlice from "./slices/defaultValuesSlice.js"
import creativesSlice from "./slices/creativesSlice.js"
import facebookAdCreativesSlice from "./slices/facebookAdCreativesSlice.js"
import creativeGroupingSlice from "./slices/creativeGroupingSlice.js"
import adPostAttemptsSlice from "./slices/adPostAttemptsSlice.js"
import fbAuthSlice from "./slices/fbAuthSlice.js"
import { all } from "axios"

export const store = configureStore({
  reducer: {
    filesAndFolders: filesAndFoldersSlice,
    campaigns: campaignsSlice,
    adSets: adSetsSlice,
    allAdSets: allAdSetsSlice,
    auth: authSlice,
    user: userSlice,
    ads: adsSlice,
    landingPages: landingPagesSlice,
    adCopies: adCopiesSlice,
    facebookPages: facebookPagesSlice,
    defaultValues: defaultValuesSlice,
    creative: creativesSlice,
    facebookAdCreatives: facebookAdCreativesSlice,
    groupedCreatives: creativeGroupingSlice,
    adPostAttempts: adPostAttemptsSlice,
    fbAuth: fbAuthSlice,
  },
})
